import styled from "styled-components";

export const ProductSelectWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ProductSelectBox = styled.div`
  width: 308px;
  background: #fff;
  border-radius: 12px;
  padding: 24px 15px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ProductSelectHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  > img {
    width: 100px;
    height: 100px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid #f0f0f0;
  }
`;

export const ProductSelectInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100px;

  > .row {
    display: flex;
    flex-direction: column;
    gap: 4px;
    > .title {
      color: #000;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }

    > .value {
      color: #000;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
  }
`;

export const ProductSelectCountBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: -1px;
`;

export const ProductSelectCountBox = styled.div<{ width: string }>`
  border: 1px solid var(--Black-200, #b7b7b7);
  height: 25px;
  width: ${(props) => props.width};
  display: flex;
  align-items: center;
  justify-content: center;

  overflow: hidden;
  color: #121212;
  text-overflow: ellipsis;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const ProductSelectTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
`;

export const ProductSelectButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const ProductSelectLeftButton = styled.div`
  flex: 1;
  height: 48px;
  background: #fff;
  color: var(--Purple-300, #6436e7);
  text-align: center;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.165px;

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
`;

export const ProductSelectRightButton = styled.div`
  flex: 1;
  height: 48px;
  background: #6436e7;
  border-radius: 8px;

  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.165px;
`;
